import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { AppRoute } from 'app/app-layout/constants/app-route.enum';

@Component({
  selector: 'cz-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})

export class FooterComponent {

  @Input() public readonly surveyProgress: number;

  constructor(private _router: Router) {}

  public isSurveyRoute(): boolean {
    let route: string = this._router.url;
    const paramIndex: number = this._router.url.indexOf('?');
    route = route.substring(0, paramIndex !== -1 ? paramIndex : route.length);

    return route === `/${AppRoute.survey}`;
  }
}
